import { httpBatchLink } from '@trpc/client'
import { env } from '@/lib/config/environment'
import { trpc } from '@/lib/trpc'

export function createTrpcClient() {
  return trpc.createClient({
    links: [
      httpBatchLink({
        url: `${env.VITE_API_URL.replace(/\/$/, '')}/api`,
        fetch(url, options) {
          return fetch(url, {
            ...options,
            credentials: 'include',
            headers: {
              ...options?.headers,
              'X-Request-ID': crypto.randomUUID(),
            },
          })
        },
      }),
    ],
  })
}
